const ClientInformationConfig = {
  collection: "client_information",
  single: true,
  fields: [
    "id",
    "date_updated",
    "header",
    "client_name_label",
    "client_name_placeholder",
    "country_label",
    "country_placeholder",
    "state_label",
    "state_placeholder"
  ],

  adapter: class ClientInformation {
    constructor(clientInfo) {
      Object.assign(this, clientInfo);
    }
  }
};

export default ClientInformationConfig;
